import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'

import { ToggleButton } from './ui'

export const ActionPanelToggle = ({
  isExpanded,
  setIsExpanded,
}: {
  isExpanded: boolean
  setIsExpanded: (isExpanded: boolean) => void
}) => {
  const { formatMessage } = useIntl()

  const label = formatMessage({
    id: `Listings.ListView.actionPanel.toggle.${
      isExpanded ? 'collapse' : 'expand'
    }`,
  })

  return (
    <ToggleButton
      aria-label={label}
      onClick={() => setIsExpanded(!isExpanded)}
      type="button"
    >
      <FontAwesomeIcon icon={isExpanded ? faChevronRight : faChevronLeft} />
    </ToggleButton>
  )
}
